import React from 'react'

import NavigationMenuSection from "../../menu-items/section/section"
import NavigationMenuItemTag from "../../menu-items/tag/menu-item-tag"
import MainMenu_SectionReorderableWithMore from "../../components/menu-controller/menu-section-reordable-with-more";
import ProjectSession from "../../../../core/model2/project/project-session";
import getOrderedTags from "./actions/get-ordered-tags";
import saveTagsSortPositions from "./actions/save-sort-position";
import openNewTag from "./actions/open-new-tag";

type Props = {
    tags                : ProjectSession[]
    parentProjectId?    : ID
    showAdd             : boolean
}

const SHOW_MORE_THRESHOLD: number   = 5

// const debug = "NavigationMenuProjectsTags"
const debug = false

export default class NavigationMenu_ProjectsTags extends React.Component<Props> {

    onReorderEnd = (items:any) => {
        debug && console.log(debug, 'onReorderEnd', items)

        saveTagsSortPositions(items, this.props.tags)
    }

    onNewTagClick = ()=>{
        debug && console.log(debug, 'onNewTagClick', this.props.parentProjectId)

        openNewTag(this.props.parentProjectId)
    }

    render() {

        let components: any[] = _.map(getOrderedTags(this.props.tags), (item, key)=>({
            item        : item,
            component   : <NavigationMenuItemTag key       = {key}
                                                 project   = {item}
                                                 colorized = {true}/>
        }))

        return (
            <NavigationMenuSection name         = "Tags"
                                   systemName   = "projectsTags"
                                   collapsible  = {true}
                                   counter      = {this.props.tags.length}>

                <MainMenu_SectionReorderableWithMore countVisibleItems  = {5}
                                                     moreTitle          = "All Tags"
                                                     newItemTitle       = "New tag"
                                                     components         = {components}
                                                     settingsKey        = "project-tags"
                                                     showAdd            = {this.props.showAdd}
                                                     onReorderEnd       = {this.onReorderEnd}
                                                     onClickNew         = {this.onNewTagClick}/>

            </NavigationMenuSection>
        )
    }
}
